/**
 * MODULE: _shared/frontend/lib/frontend/mobile/mobileShellDetection.ts
 * PURPOSE: Viewport + touch heuristics for mobile shell mode (shared across shell and core slices).
 * PUBLIC_API: MOBILE_VIEWPORT_MAX_PX, MOBILE_SHELL_TOUCH_MAX_PX, readMobileShellActive, MOBILE_SHELL_MEDIA_QUERIES
 * SIDE_EFFECTS: Reads window.matchMedia when called in browser
 * AGENT_SAFETY: SAFE
 */

/** Matches Tailwind `md` (768px) — narrow viewport breakpoint. */
export const MOBILE_VIEWPORT_MAX_PX = 767;

/** Touch phones in landscape can exceed 767px; still use mobile shell up to this width. */
export const MOBILE_SHELL_TOUCH_MAX_PX = 1023;

const NARROW_MQ = `(max-width: ${MOBILE_VIEWPORT_MAX_PX}px)`;
const COARSE_TOUCH_MQ = '(hover: none) and (pointer: coarse)';

export function readNarrowViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(NARROW_MQ).matches;
}

export function readCoarseTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(COARSE_TOUCH_MQ).matches;
}

/** True when the app should use mobile shell chrome and compact page layout. */
export function readMobileShellActive(): boolean {
  if (typeof window === 'undefined') return false;
  if (readNarrowViewport()) return true;
  if (readCoarseTouchDevice() && window.innerWidth <= MOBILE_SHELL_TOUCH_MAX_PX) {
    return true;
  }
  return false;
}

export const MOBILE_SHELL_MEDIA_QUERIES = [NARROW_MQ, COARSE_TOUCH_MQ] as const;
